module.exports = __webpack_public_path__ + "img/621.dde5f711.jpg";